const baseUrl: string = process.env.REACT_APP_API_URL || '';

class ChangePassword {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public post = (params: any) => ({
        baseUrl,
        method: 'patch',
        params,
        uri: this.uri,
    });
}

export default new ChangePassword('/auth/v1/change-password');



// WEBPACK FOOTER //
// ./src/libraries/api/change-password.tsx